import useMyUser from "src/api/hooks/useMyUser";
import { useCallback, useEffect, useState } from "react";
import useAssignments from "src/api/hooks/useAssignment";
import { useLocation, useParams } from "react-router-dom";
import { InspectionResponse } from "src/types/InspectionUpdateRequest";
import { LocalStorageKeys } from "./localStorageKeys";

export function useApplyFilters(dependencies?: string[]) {
  const { data: myUser } = useMyUser();
  const assignments = useAssignments();
  const [filters, setFilters] = useState<Record<string, string>>({});
  const location = useLocation();
  useEffect(() => {
    const filter = localStorage.getItem(LocalStorageKeys.filter);
    if (filter) {
      setFilters(JSON.parse(filter || "{}"));
    }
  }, [location.pathname]);

  const itemIsTruthyFunction = useCallback(
    (item: InspectionResponse) => {
      let searchMatch: boolean = true;
      let deviationTypeMatch = true;
      let statusMatch = true;
      let notOnlyAssignedToUser = true;
      if (filters.assignedToUserId && myUser?.id) {
        notOnlyAssignedToUser = !!assignments.data?.some(
          (a) => a.inspectionId === item.id && a.userId === myUser.id
        );
      }

      let startDateMatch = true;
      let groupMatch = true;
      let endDateMatch = true;
      let user = true;
      let exitCategoryMatch = true;
      let objectTypeMatch = true;
      if (filters.searchText) {
        searchMatch = Object.keys(item).some((key) => {
          if (
            String(item[key as keyof InspectionResponse]).includes(
              filters.searchText || ""
            )
          ) {
            return true;
          }
        });
      }
      if (filters.deviationType) {
        deviationTypeMatch = filters.deviationType === item.deviationType;
      }
      if (filters.status) {
        statusMatch = filters.status === item.status;
      }
      if (filters.startDate && item.createdAt) {
        startDateMatch = new Date(filters.startDate) < new Date(item.createdAt);
      }
      if (filters.endDate && item.createdAt) {
        endDateMatch = new Date(filters.endDate) > new Date(item.createdAt);
      }
      if (filters.groups) {
        groupMatch = filters.groups.split(",").includes(String(item.groupId));
      }
      if (filters.userId) {
        user = Number(filters.userId) === item.userId;
      }
      if (filters.exitCategory) {
        exitCategoryMatch = filters.exitCategory === item.finishCategory;
      }
      if (filters.objectType) {
        objectTypeMatch = filters.objectType === item.objectType;
      }
      const boolResult =
        searchMatch &&
        deviationTypeMatch &&
        statusMatch &&
        startDateMatch &&
        endDateMatch &&
        groupMatch &&
        user &&
        exitCategoryMatch &&
        notOnlyAssignedToUser &&
        objectTypeMatch;

      return boolResult;
    },
    [filters, myUser, assignments, ...(dependencies || [])]
  );

  const filterfunction = useCallback(
    (items: InspectionResponse[]) => {
      if (!items) return items;
      const newItems = items.filter(itemIsTruthyFunction);
      return newItems;
    },
    [itemIsTruthyFunction]
  );
  return filterfunction;
}
